import React from 'react';

import { MessageDeliveryDetailsEditableRow } from './message-delivery-details-editable-row';

type InputProps = {
  title: string;
  messageDetails: Array<AnnouncementDeliverabilityDetail>;
  updatePhoneNumber: (employeeId: number, phoneNumber: string) => void;
  retrySendMessage: (handleRetrySendMessage: AnnouncementDeliverabilityDetail) => Promise<boolean>;
};

export const MessageDeliveryDetailsEditable = (props: InputProps) => {
  const { title, messageDetails, updatePhoneNumber, retrySendMessage } = props;

  return (
    <div className="u-margin-bottom-2x">
      <div className="typo-bold u-padding-bottom-sm">{title}</div>
      {messageDetails.map((messageDetail) => (
        <MessageDeliveryDetailsEditableRow
          key={messageDetail.employeeId}
          messageDetail={messageDetail}
          updatePhoneNumber={updatePhoneNumber}
          retryMessage={retrySendMessage}
        />
      ))}
    </div>
  );
};
